import isEqual from 'lodash/isEqual';
// eslint-disable-next-line no-restricted-imports
import moment from 'moment';
import {
  deserializeYesplanAPIDateAndTime,
  todayDateObject
} from '../libs/dateTimeUtilities';

const durationSinceNotification = (notification) => {
  const now = todayDateObject();
  const notificationSentDateObject = notification.getTimestamp();
  return moment.duration(now.diff(notificationSentDateObject));
};

export default class AbstractNotification {
  constructor(id, timestampString, isRead, notificationMessage) {
    this.id = id;
    this.timestamp = deserializeYesplanAPIDateAndTime(timestampString);
    this.isRead = isRead;
    this.notificationMessage = notificationMessage;
  }

  getTimestamp() {
    return this.timestamp;
  }

  getIsRead() {
    return this.isRead;
  }

  getNotificationMessage() {
    return this.notificationMessage;
  }

  isPublishOrRevokeNotification() {
    return false;
  }

  isUpdateNotification() {
    return false;
  }

  isTimesheetNotification() {
    return false;
  }

  isRosterNotification() {
    return false;
  }

  getPath() {
    throw new Error('getPath method must be implemented by a subclass');
  }

  getNotifications(rosterNotifications, updateNotifications, timesheetNotifications) {
    throw new Error('getNotifications method must be implemented by a subclass');
  }

  equal(notification) {
    return (
      this.id === notification.id &&
      this.timestamp.isSame(notification.getTimestamp()) &&
      this.isRead === notification.getIsRead() &&
      isEqual(this.notificationMessage, notification.getNotificationMessage())
    );
  }

  markAsRead() {
    this.isRead = true;
  }

  printTimeSinceNotificationText() {
    const duration = durationSinceNotification(this);
    const minutes = duration.asMinutes();
    const hours = duration.asHours();
    /* To avoid the "-1 minutes ago" case, test on <= 0 */
    if (Math.floor(minutes) <= 0) {
      return i18n('just now');
    }
    if (minutes < 60) {
      return i18n('{minutes} minute(s) ago', {
        minutes: Math.floor(minutes)
      });
    }
    if (hours < 24) {
      return i18n('{hours} hour(s) ago', {
        hours: Math.floor(hours)
      });
    }
    if (hours >= 24 && hours < 48) {
      return i18n('yesterday');
    }
    return i18n('{days} day(s) ago', {
      days: Math.floor(hours / 24)
    });
  }
}
